import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default {
  name: 'ledParam_page',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  components: {
    smartControlItemSel: function smartControlItemSel() {
      return import('../smartControl/smartControlItem_sel.vue');
    },
    smartControlSel: function smartControlSel() {
      return import('../smartControl/smartControl_sel');
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '参数',
        addFunName: 'ledParamAdd',
        modifyFunName: 'ledParamModify',
        delFunName: 'ledParamDel',
        queryFunName: 'ledParamQuery',
        detailFunName: 'ledParamDetail'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        ledId: this.current.id,
        sortField: 'create_time',
        type: ''
      },
      formData: {
        ledId: this.current.id,
        remark: null,
        type: 'Text'
      },
      rules: {
        type: [{
          required: true,
          message: '请选择参数类型',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入参数代码',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '请输入值',
          trigger: 'blur'
        }],
        valueLength: [{
          required: true,
          message: '请输入设备值长度',
          trigger: 'blur'
        }],
        smartControlId: [{
          required: true,
          message: '请选择控制器参数',
          trigger: 'blur'
        }],
        smartControlItemId: [{
          required: true,
          message: '请选择检测项',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '130px',
      emptyFormData: {},
      smartControl_show: false,
      smartControlItem_show: false
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    back: function back() {
      this.$emit('child-go-led');
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (!this.formData.type) {
        this.formData.type = 'Text';
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
      this.formData.upperCode = this.searchForm.upperCode;
    },
    edit: function edit(_ref) {
      var _this = this;
      var id = _ref.id,
        smartControlName = _ref.smartControlName,
        smartControlItemTypeName = _ref.smartControlItemTypeName;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
          smartControlName: smartControlName,
          smartControlItemTypeName: smartControlItemTypeName
        }));
        _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
        _this.editDialogShow = true;
      });
    } // 选择控制器
    ,
    smartControlSel: function smartControlSel(data) {
      console.log('smartControlSel', data);
      if (data) {
        this.$set(this.formData, 'smartControlId', data.id);
        this.$set(this.formData, 'smartControlName', data.name);
      }
      this.smartControl_show = false;
    },
    smartControlItemClick: function smartControlItemClick() {
      if (!this.formData.smartControlId) {
        this.$message.info('请先选择控制器！');
        return;
      }
      this.smartControlItem_show = true;
    },
    smartControlItemSel: function smartControlItemSel(data) {
      if (data) {
        this.$set(this.formData, 'smartControlItemId', data.id);
        this.$set(this.formData, 'smartControlItemTypeName', data.typeName);
      }
      this.smartControlItem_show = false;
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};